import styled from 'styled-components';
import { DARK_SKY } from '../../theme';

const ArticlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${DARK_SKY};
  position: relative;
  margin: 0 auto 2rem auto;
`;

export { ArticlesContainer };